import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI';
import { ProjectStateClass } from './interfaces/projectStateClass';
import moment from 'moment';

const initialState: ProjectStateClass = {
    isLoading: true,
    status: 'idle',
    projectList: [],
    selectedRecord: {},
    isReloadAllocationHours: false,
    isReload: false,
    currentPage: 1,
    start: 0,
    accountprojectid: 0,
    projectTeamList: [],
    addProjectTeamList: [],
    selectedProjectTeamList: [],
    deletedProjectTeamList: [],
    //pagination Start
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false,
    orderDir: 'asc',
    order: '4',
    //pagination End
    assignedprojectList: [],
    optionProjectValue: "0",
    optionProjectText: "All",
    isFromTemplate: false,
    isAllowPreferences: true,
    projectCodePrefix: "",
    showAdditionalProjectInformationType: 0,
    sortTaskBy: "",
    autoGenerateProjectCode: false,
    allocationHoursInProjectTeam: false,
    enableGanttChart: false,
    showCompletedProjectInProjectGrid: false,
    showClientDepartmentInProject: false,
    includeCurrentYearInProjectCode: false,
    automaticallyIncludeAdminitratorInProjectTeam: false,
    isProjectTemplateMandatory: false,
    showProjectNameInTask: false,
    showClientNameInTask: false,
    isAutoCompleteTask: false,
    allocationHoursInProjectTaskTeam: false,
    autoProjectCode: "",
    isTemplate: false,
    searchProjectTeamList: [],
    isAttachment: false,
    ProjectFilterValues: {
        ProjectCode: '',
        AccountClientId: 0,
        AccountCompleteStatusId: -1,
        AccountStatusId: '0',
        AccountProjectTypeId: 0,
        IncludeDateRange: 0,
        StartDate:  moment().format('YYYY-MM-DD'),
        EndDate: moment().format('YYYY-MM-DD'),
        IsDisabled: 0
    },
    activeFilter: true,
    projectTeamAllocationHoursList: [],
    accountProjectId: 0,
    accountEmployeeId: 0,
    renderFromSummary: false
}
interface IThunkApi {
    state: {
        project: ProjectStateClass;
    },
}

export const GetAccountProjectPreferences = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Projects/GetAccountProjectPreferences',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/Projects/GetAccountProjectPreferencesWithAutoProjectCode`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAccounyProjectList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/getAccounyProjectList',
        async (arg, thunkApi) => {

            const { isTemplate, startRec, search, pageNo, pageSize, orderDir, order } = thunkApi.getState().project;
            const requestData: any = {
                IsTemplate: isTemplate,
                StartRec: startRec,
                PageSize: pageSize,
                PageNo: pageNo,
                OrderDir: orderDir,
                Order: order,
                IsForReact: 1,
                Search: search ? search : ''
            };
            const queryString = new URLSearchParams(requestData).toString();
            let SearchParamsValues = `0,0,-1,0,'',0,'',''`;
       
            if (arg) {
                const { ProjectCode,AccountEmployeeId, AccountClientId, AccountCompleteStatusId, AccountStatusId, IsDisabled, AccountProjectTypeId,IncludeDateRange,StartDate,EndDate  } = arg;
                SearchParamsValues = [
                    AccountEmployeeId || 0,
                    AccountClientId || 0,
                    AccountCompleteStatusId || -1,
                    // AccountStatusId || 0,
                    // Array.isArray(AccountStatusId) ? `${AccountStatusId.join(',')}` : (AccountStatusId || 0),
                    `'${Array.isArray(AccountStatusId) ? AccountStatusId.join(',') : (AccountStatusId || 0)}'`,
                    encodeURIComponent(ProjectCode || ''),
                    IsDisabled ?? 0,
                    AccountProjectTypeId || 0,
                    IncludeDateRange ? 1 : 0,
                    StartDate || '',
                    EndDate || '',
                ].join(',');
            }

            const response = await fetchAPI(`api/V2/Projects/GetProjectDatatable/${SearchParamsValues}?${queryString}`, `Get`, '', true);

            //const response = await fetchAPI(`api/V2/Projects/GetProjectDatatable/${isTemplate}/${startRec}/${pageSize}/${pageNo}/${1}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getProjectTeam = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Employees/getProjectTeam',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/Employees/GetCurrentActiveEmployees/`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getSelectedProjectTeamMember = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/GetCurrentActiveEmployeesWithSelectedTeamMember',
        async (arg, thunkApi) => {
            const { accountprojectid } = thunkApi.getState().project;
            const response = await fetchAPI(`api/V2/Employees/GetCurrentActiveEmployeesWithSelectedTeamMember/${arg}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

// export const getAccountProjectsByAccountIdAndIsDisabledAsync = createAsyncThunk
//     <any, void, IThunkApi>
//     (
//         'Projects/V2/getAssigned',
//         async (arg, thunkApi) => {
//             const response = await fetchAPI('api/V2/Projects/Assigned', 'Get', '', true);
//             const json = await response.json();
//             return json;
//         }
//     )

export const addAccountProject = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/addAccountProject',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Projects/', 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProject = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/updateAccountProject',
        async (arg, thunkApi) => {
            const { accountprojectid } = thunkApi.getState().project;
            const response = await fetchAPI(`api/V2/Projects/UpdateAccountProjectWithProjectTeam/${accountprojectid}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProjectStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/updateAccountProjectStatus',
        async (arg, thunkApi) => {
            let { IsDisabled, AccountProjectId } = arg
            const response = await fetchAPI(`api/V2/Projects/UpdateAccountProjectStatus/${IsDisabled}/${AccountProjectId}`, 'POST', true);
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountProject = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/deleteAccountProject',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Projects/' + arg, 'DELETE', '', true);
            const json = await response.json();
            return json;
        }
    )

export const deleteSelectedAccountProjects = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/deleteSelectedAccountProjects",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Projects/DeleteSelectedProjects/', 'Delete', arg, true);
            const json = await response.json();
            return json;

        }
    )

export const getAssignedProjectList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/getAssignedProjectList',
        async (arg, thunkApi) => {
            const { startRec, search, pageNo, pageSize } = thunkApi.getState().project;
            const response = await fetchAPI(`api/V2/Projects/GetAssignedProjectsDatatable/${Number(arg)}/${startRec}/${pageSize}/${pageNo}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAccountProjectByAccountProjectIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/getAccountProjectByAccountProjectId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Projects/' + arg, 'Get', '', true);
            const json = await response.json();
            return json;
        }
    )
/*     export const getDataByAllocationHours = createAsyncThunk
    <any, any, IThunkApi>
    (
        'project/getProjectTeam',
        async (arg, thunkApi) => {
            //const { accountProjectId, accountEmployeeId} = thunkApi.getState().project;
            const { accountProjectId, accountEmployeeId } = arg;
            const response = await fetchAPI(`api/V2/Projects/GetDataByAllocationHours/${accountProjectId}/${accountEmployeeId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    ) */
    
        export const getDataByAllocationHours = createAsyncThunk<
        any, { accountProjectId: number, accountEmployeeId: number, accountProjectEmployeeId: number }, IThunkApi
    >(
        'project/getProjectTeam',
        async ({ accountProjectId, accountEmployeeId, accountProjectEmployeeId }, thunkApi) => {
            const response = await fetchAPI(
                `api/V2/Projects/GetDataByAllocationHours/${accountProjectId}/${accountEmployeeId}`, 
                `Get`, '', true
            );
            const json = await response.json();
            return json;
        }
    );

    export const deleteAllocationHours = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/deleteAllocationHours",
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/v2/Projects/DeleteAllocationHours/${arg}`, 'Delete', arg, true);
            const json = await response.json();
            return json;

        }
    )

    export const updateAccountProjectEmployeeAllocationHoursAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/updateAccountProjectEmployeeAllocationHours",
        async (arg, thunkApi) => {
            const { AccountProjectEmployeeAllocationHoursId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Projects/UpdateAccountProjectEmployeeAllocationHours/" + AccountProjectEmployeeAllocationHoursId, "POST", arg, true);
            const json = response.json();
            return json;
        }
    )

    export const addAccountProjectEmployeeAllocationHoursAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/addAccountProjectEmployeeAllocationHours",
        async (arg, thunkApi) => {
            const { AccountProjectEmployeeAllocationHoursId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Projects/AddAllocationHours/", "POST", arg, true);
            const json = response.json();
            return json;
        }
    )
    

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsTemplate: (state, action: PayloadAction<boolean>) => {
            state.isTemplate = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
            state.startRec = 0;
            // state.pageSize = 10;
            state.pageNo = 1;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.orderDir = action.payload.orderDir;
            state.order = action.payload.order;
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateAccountProjectId: (state, action: PayloadAction<any>) => {
            state.accountprojectid = action.payload;
        },
        updateAllSelectedAndUnSelected: (state, action: PayloadAction<any>) => {
            state.addProjectTeamList = [];
            state.projectTeamList = action.payload;
            state.searchProjectTeamList = action.payload;  
        },
        updateProjectTemplateStatus: (state, action: PayloadAction<any>) => {
            state.isFromTemplate = action.payload;
        },
        // updateSelectedResource: (state, action: PayloadAction<any>) => {
        //     const index = state.projectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
        //     if (state.accountprojectid != 0) {
        //         let selectedTaskTeamListIndexs = state.selectedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
        //         let addTeamlistIndexs = state.addProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
        //         let deletedTaskTeamListIndex = state.deletedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
        //         var obj = state.projectTeamList[index];
        //         var objSearch = state.searchProjectTeamList[index];
        //         if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
        //             obj.IncludeTeam = 1;
        //             objSearch.IncludeTeam = 1;
        //             state.addProjectTeamList.push(state.projectTeamList[index]);
        //         }
        //         if (selectedTaskTeamListIndexs == -1 && deletedTaskTeamListIndex != -1) {
        //             obj.IncludeTeam = 1;
        //             objSearch.IncludeTeam = 1;
        //             state.selectedProjectTeamList.push(state.deletedProjectTeamList[deletedTaskTeamListIndex]);
        //             state.deletedProjectTeamList.splice(state.deletedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId), 1);
        //         }
        //     } else {
        //         const newArray = [...state.projectTeamList];
        //         newArray[index] = { ...newArray[index], IncludeTeam: 1 };
        //         state.projectTeamList = newArray;
        //         state.searchProjectTeamList = newArray;
        //     }
        // },
        updateSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.projectTeamList.findIndex(
                (item) => item.AccountEmployeeId === action.payload.AccountEmployeeId
            );
            if (index === -1) {
                               return;
            }
            const obj = state.projectTeamList[index];
            obj.IncludeTeam = obj.IncludeTeam === 1 ? 0 : 1;
            const searchIndex = state.searchProjectTeamList.findIndex(
                (item) => item.AccountEmployeeId === action.payload.AccountEmployeeId
            );
        
            if (searchIndex !== -1) {
                state.searchProjectTeamList[searchIndex] = { ...obj };
            }
            if (obj.IncludeTeam === 1) {
                if (!state.addProjectTeamList.some((item) => item.AccountEmployeeId === obj.AccountEmployeeId)) {
                    state.addProjectTeamList.push(obj);
                }
            } else {
                state.addProjectTeamList = state.addProjectTeamList.filter(
                    (item) => item.AccountEmployeeId !== obj.AccountEmployeeId
                );
                state.selectedProjectTeamList = state.selectedProjectTeamList.filter(
                    (item) => item.AccountEmployeeId !== obj.AccountEmployeeId
                );
            }
        },



        updateUnSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.projectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
            if (state.accountprojectid != 0) {
                let selectedTaskTeamListIndexs = state.selectedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
                let addTeamlistIndexs = state.addProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
                let deletedTeamIndex = state.deletedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId);
                var obj = state.projectTeamList[index];
                var objSearch = state.searchProjectTeamList[index];
                if (addTeamlistIndexs != -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.addProjectTeamList.splice(state.addProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId), 1);
                }
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedProjectTeamList.push(state.projectTeamList[index]);
                    state.selectedProjectTeamList.splice(state.selectedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId), 1);
                }
                if (selectedTaskTeamListIndexs != -1 && deletedTeamIndex == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedProjectTeamList.push(state.selectedProjectTeamList[selectedTaskTeamListIndexs]);
                    state.selectedProjectTeamList.splice(state.selectedProjectTeamList.findIndex((item) => item.AccountEmployeeId === action.payload.AccountEmployeeId), 1);
                }
            } else {
                const newArray = [...state.projectTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 0 };
                state.projectTeamList = newArray;
                state.searchProjectTeamList = newArray;
            }
        },
        // selectedAndUnSelectedOnEditMode: (state, action: PayloadAction<any>) => {
        //     state.projectTeamList.map((item) => {
        //         if (action.payload) {
        //             let deletedTeamListIndex = state.deletedProjectTeamList.findIndex(x => x.AccountEmployeeId == item.AccountEmployeeId);
        //             let addTeamlistIndexs = state.addProjectTeamList.findIndex((x) => x.AccountEmployeeId === item.AccountEmployeeId);
        //             let selectedTeamListIndex = state.selectedProjectTeamList.findIndex((x) => x.AccountEmployeeId === item.AccountEmployeeId);
        //             if (selectedTeamListIndex == -1 && addTeamlistIndexs == -1 && deletedTeamListIndex == -1) {
        //                 if (item.IncludeTeam == 0) {
        //                     item.IncludeTeam = 1;
        //                     state.addProjectTeamList.push(item);
        //                 } else {
        //                     state.selectedProjectTeamList.push(item);
        //                 }
        //             }
        //             if (deletedTeamListIndex != -1) {
        //                 item.IncludeTeam = 1;
        //                 state.selectedProjectTeamList.push(state.deletedProjectTeamList[deletedTeamListIndex]);
        //                 state.deletedProjectTeamList.splice(state.deletedProjectTeamList.findIndex((deleteItem) => deleteItem.AccountEmployeeId === item.AccountEmployeeId), 1);
        //             }
        //             if (selectedTeamListIndex != -1) {
        //                 item.IncludeTeam = 1;
        //                 if (state.addProjectTeamList.findIndex(x => x.AccountEmployeeId == item.AccountEmployeeId) == -1) {
        //                     state.addProjectTeamList.push(item);
        //                 }
        //             }
        //         } else {
        //             item.IncludeTeam = 0;
        //             let selectedTaskTeamListIndex = state.selectedProjectTeamList.findIndex(x => x.AccountEmployeeId == item.AccountEmployeeId);
        //             if (selectedTaskTeamListIndex != -1) {
        //                 state.deletedProjectTeamList.push(state.selectedProjectTeamList[selectedTaskTeamListIndex]);
        //                 state.selectedProjectTeamList.splice(state.selectedProjectTeamList.findIndex(x => x.AccountEmployeeId == item.AccountEmployeeId), 1);
        //             }
        //             state.addProjectTeamList.splice(state.addProjectTeamList.findIndex(x => x.AccountEmployeeId == item.AccountEmployeeId), 1);
        //         }
        //     });
        //     state.searchProjectTeamList = state.projectTeamList;
        // },


        selectedAndUnSelectedOnEditMode: (state, action: PayloadAction<any>) => {
            const selectAll = action.payload;
        
            state.projectTeamList.forEach((item) => {
                if (selectAll) {
                    let isDeleted = state.deletedProjectTeamList.findIndex(
                        (x) => x.AccountEmployeeId === item.AccountEmployeeId
                    ) !== -1;
                    let isAdded = state.addProjectTeamList.findIndex(
                        (x) => x.AccountEmployeeId === item.AccountEmployeeId
                    ) !== -1;
        
                    if (!isDeleted && !isAdded) {
                        item.IncludeTeam = 1;
                        state.addProjectTeamList.push(item);
                    }
                } else {
                    item.IncludeTeam = 0;
        
                    // Move to deleted list if already selected
                    const selectedIndex = state.selectedProjectTeamList.findIndex(
                        (x) => x.AccountEmployeeId === item.AccountEmployeeId
                    );
                    if (selectedIndex !== -1) {
                        state.deletedProjectTeamList.push(state.selectedProjectTeamList[selectedIndex]);
                        state.selectedProjectTeamList.splice(selectedIndex, 1);
                    }
        
                    // Remove from added list
                    state.addProjectTeamList = state.addProjectTeamList.filter(
                        (x) => x.AccountEmployeeId !== item.AccountEmployeeId
                    );
                }
            });
        
            // Update searchProjectTeamList with the same IncludeTeam values
            state.searchProjectTeamList = state.projectTeamList.map((item) => ({
                ...item,
                IncludeTeam: item.IncludeTeam,
            }));
        },


        checkedState: (state, action) => {
            const currentindex = state.projectList.findIndex((item) => item.AccountProjectId == action.payload);
            const newArray = [...state.projectList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.projectList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.projectList.findIndex((item) => item.AccountProjectId == action.payload);
            const newArray = [...state.projectList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.projectList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.projectList.map((item) => ({
                ...item,
                isSelected: 1
            }));
            state.projectList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.projectList.map((item) => ({
                ...item,
                isSelected: 0
            }));
            state.projectList = newArray;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        // searchProjectTeam: (state, action: PayloadAction<any>) => {
        //     const query = action.payload.toLowerCase();
        //     // var searchData = state.searchProjectTeamList.filter(
        //     //     x => x.FirstName && x.FirstName.toLowerCase().indexOf(query) > -1
        //     // );
        //     // var queryLower = query ? query.toLowerCase() : '';
        //     // var searchData = state.searchProjectTeamList.filter(
        //     //     x => (x.FirstName && x.FirstName.toLowerCase().includes(query)) ||
        //     //         (x.LastName && x.LastName.toLowerCase().includes(query))
        //     // );
        //     var searchData = state.searchProjectTeamList.filter(
        //         x => `${x.FirstName} ${x.LastName}` && `${x.FirstName} ${x.LastName}`.toLowerCase().indexOf(query) > -1
        //     );
        //     console.log('searchData', searchData)
        //     state.projectTeamList = searchData;
        // },



        searchProjectTeam: (state, action: PayloadAction<any>) => {
            const query = action.payload.toLowerCase();
                if (query.trim() === '') {             
                state.projectTeamList = state.searchProjectTeamList.map((item) => {
                    const isSelected = state.addProjectTeamList.some((x) => x.AccountEmployeeId === item.AccountEmployeeId);
                    return { ...item, IncludeTeam: isSelected ? 1 : item.IncludeTeam };
                });
            } else {               
                state.projectTeamList = state.searchProjectTeamList
                    .filter((x) => `${x.FirstName} ${x.LastName}` && `${x.FirstName} ${x.LastName}`.toLowerCase().includes(query))
                    .map((item) => {
                        const isSelected = state.addProjectTeamList.some((x) => x.AccountEmployeeId === item.AccountEmployeeId);  
                        return { ...item, IncludeTeam: isSelected ? 1 : item.IncludeTeam };
                    });
            }
        },

        resetProjectTeam: (state) => {
            state.projectTeamList = [];
            state.addProjectTeamList = [];
            state.selectedProjectTeamList = [];
            state.deletedProjectTeamList = [];
            state.searchProjectTeamList = [];
        },
        updateProjectAttachment: (state, action: PayloadAction<boolean>) => {
            state.isAttachment = action.payload;
        },
        updateMyProjectFilters: (state, action: PayloadAction<any>) => {
            state.ProjectFilterValues = { ...state.ProjectFilterValues, ...action.payload };
            state.startRec = 0;
            // state.pageSize = 10;
            state.pageNo = 1;

        },
        updateActiveFilter: (state, action: PayloadAction<boolean>) => {
            state.activeFilter = action.payload;
        },
        isEditableAllocationHoursList: (state, action) => {
            const currentindex = state.projectTeamAllocationHoursList.findIndex((item) => item.AccountProjectEmployeeAllocationHoursId == action.payload);
            const newArray = [...state.projectTeamAllocationHoursList];
            newArray[currentindex] = { ...newArray[currentindex], IsEditable: true };
            state.projectTeamAllocationHoursList = newArray;
        },
        setValuesAllocationHours: (state, action) => {
            const index = state.projectTeamAllocationHoursList.findIndex((item) => item.AccountProjectEmployeeAllocationHoursId === action.payload.Id);
            console.log("Found index:", index);
            const newArray = [...state.projectTeamAllocationHoursList];
            newArray[index] = { ...newArray[index], AllocationHours: action.payload.AllocationHours != '' ? action.payload.AllocationHours : 0 };
            console.log("Found setDatesAllocationHours: projectTeamAllocationHoursList", newArray);
            state.projectTeamAllocationHoursList = newArray;
        },
        deleteAllocationHours: (state, action) => {
            state.projectTeamAllocationHoursList = state.projectTeamAllocationHoursList.filter(
                (item) => item.AccountProjectEmployeeAllocationHoursId !== action.payload.Id
            );
        },
        setDatesAllocationHours: (state, action) => {            
            
            const index = state.projectTeamAllocationHoursList.findIndex((item) => item.AccountProjectEmployeeAllocationHoursId === action.payload.Id);
            console.log("Found index:", action);
            const newArray = [...state.projectTeamAllocationHoursList];
            console.log("setDatesAllocationHours", action.payload.StartDate)
            if (action.payload.StartDate || action.payload.StartDate === null) {
                newArray[index] = { ...newArray[index], StartDate: action.payload.StartDate !== null && action.payload.StartDate != '' ? action.payload.StartDate : '' };
            } else {
                newArray[index] = { ...newArray[index], EndDate: action.payload.EndDate !== null && action.payload.EndDate != '' ? action.payload.EndDate : '' };
            }

            console.log("Found setDatesAllocationHours: projectTeamAllocationHoursList", newArray);
            state.projectTeamAllocationHoursList = newArray;
        },
        updateFromProjectSummary: (state) => {
            state.renderFromSummary = state.renderFromSummary ? false : true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccounyProjectList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccounyProjectList.fulfilled, (state, action) => {
                let ProjectList = JSON.parse(action.payload.data);
                if (ProjectList.length > 0) {
                    ProjectList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.projectList = ProjectList;
                state.isShowGrid = ProjectList.length > 0 ? true : false;
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccounyProjectList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountProjectPreferences.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetAccountProjectPreferences.fulfilled, (state, action) => {
                state.isAllowPreferences = action.payload.length > 0 && false;
                const resultAccountPreferences = <any>action.payload[0];
                state.projectCodePrefix = resultAccountPreferences.ProjectCodePrefix;
                state.showAdditionalProjectInformationType = resultAccountPreferences.ShowAdditionalProjectInformationType;
                state.sortTaskBy = resultAccountPreferences.SortTaskBy;
                state.autoGenerateProjectCode = resultAccountPreferences.AutoGenerateProjectCode === 'Yes' ? true : false;
                state.allocationHoursInProjectTeam = resultAccountPreferences.AllocationHoursInProjectTeam === 'Yes' ? true : false;
                state.enableGanttChart = resultAccountPreferences.EnableGanttChart === 'Yes' ? true : false;
                state.showCompletedProjectInProjectGrid = resultAccountPreferences.ShowCompletedProjectInProjectGrid === 'Yes' ? true : false;
                state.showClientDepartmentInProject = resultAccountPreferences.ShowClientDepartmentInProject === 'Yes' ? true : false;
                state.includeCurrentYearInProjectCode = resultAccountPreferences.IncludeCurrentYearInProjectCode === 'Yes' ? true : false;
                state.automaticallyIncludeAdminitratorInProjectTeam = resultAccountPreferences.AutomaticallyIncludeAdminitratorInProjectTeam === 'Yes' ? true : false;
                state.isProjectTemplateMandatory = resultAccountPreferences.IsProjectTemplateMandatory === 'Yes' ? true : false;
                state.showProjectNameInTask = resultAccountPreferences.ShowProjectNameInTask === 'Yes' ? true : false;
                state.showClientNameInTask = resultAccountPreferences.ShowClientNameInTask === 'Yes' ? true : false;
                state.isAutoCompleteTask = resultAccountPreferences.IsAutoCompleteTask === 'Yes' ? true : false;
                state.allocationHoursInProjectTaskTeam = resultAccountPreferences.AllocationHoursInProjectTaskTeam === 'Yes' ? true : false;
                state.autoProjectCode = resultAccountPreferences.AutoProjectCode;
            })
            .addCase(GetAccountProjectPreferences.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getProjectTeam.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectTeam.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.projectTeamList = payload;
                state.searchProjectTeamList = payload;
            })
            .addCase(getProjectTeam.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getDataByAllocationHours.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getDataByAllocationHours.fulfilled, (state, { payload, meta }) => {
                state.status = 'idle';
                // Blank row ko pehle add karein
                const blankRow = {
                    AccountProjectEmployeeAllocationHoursId: 0,
                    StartDate: '',
                    EndDate: '',
                    AllocationHours: 0,
                    AccountProjectId: meta.arg.accountProjectId,
                    AccountEmployeeId: meta.arg.accountEmployeeId,
                    AccountProjectEmployeeId: meta.arg.accountProjectEmployeeId
                };
                //state.projectTeamAllocationHoursList = payload;
                state.projectTeamAllocationHoursList = [blankRow, ...payload];
                state.isReloadAllocationHours = false


            })
            .addCase(getDataByAllocationHours.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllocationHours.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllocationHours.fulfilled, (state, action) => {
                state.projectTeamAllocationHoursList = state.projectTeamAllocationHoursList.filter(x => x.AccountProjectEmployeeAllocationHoursId != Number(action.payload.id));

                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAllocationHours.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAccountProjectEmployeeAllocationHoursAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProjectEmployeeAllocationHoursAsync.fulfilled, (state, action) => {
                state.projectTeamAllocationHoursList = state.projectTeamAllocationHoursList.filter(x => x.AccountProjectEmployeeAllocationHoursId != Number(action.payload.id));

                state.status = 'idle';
                state.isLoading = false;
                console.log("Previous isReloadAllocationHours:", action);
                if (action.payload.Result !== "failed" && action.payload.message !== "Date range conflict detected for this employee.") {
                    state.isReloadAllocationHours = !state.isReloadAllocationHours;
                }

                console.log("Updated isReloadAllocationHours:", state.isReloadAllocationHours);

            })
            .addCase(addAccountProjectEmployeeAllocationHoursAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProjectEmployeeAllocationHoursAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectEmployeeAllocationHoursAsync.fulfilled, (state, action) => {
                state.projectTeamAllocationHoursList = state.projectTeamAllocationHoursList.filter(x => x.AccountProjectEmployeeAllocationHoursId != Number(action.payload.id));

                state.status = 'idle';
                state.isLoading = false;
                state.isReloadAllocationHours = !state.isReloadAllocationHours;
            })
            .addCase(updateAccountProjectEmployeeAllocationHoursAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getSelectedProjectTeamMember.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getSelectedProjectTeamMember.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.projectTeamList = payload;
                state.searchProjectTeamList = payload;
                state.isLoading = false;
            })
            .addCase(getSelectedProjectTeamMember.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAccountProject.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProject.fulfilled, (state, { payload }) => {
               
                // if (payload[0].hasOwnProperty('Result')) {
                //     if (payload[0].Result != '') {
                //           console.log('payload[0].Result :',payload[0].Result)
                //         state.autoProjectCode = payload[0].Result;
                //     }
                // }
                if (Array.isArray(payload) && payload.length > 0 && payload[0].Result) {
                    state.autoProjectCode = payload[0].Result;
                } 
  
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(addAccountProject.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProject.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProject.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(updateAccountProject.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountProject.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountProject.fulfilled, (state, action) => {
                state.projectList = state.projectList.filter(x => x.AccountProjectId != Number(action.payload.Id));
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAccountProject.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountProjects.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteSelectedAccountProjects.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountProjects.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProjectStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectStatus.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (payload.hasOwnProperty('StatusCode')) {
                    state.projectList.map((item: any) => {
                        if (item.AccountProjectId == Number(payload.Id)) {
                            item.IsDisabled = item.IsDisabled ? false : true;
                        }
                    })
                }
                state.isLoading = false;
            })
            .addCase(updateAccountProjectStatus.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountProjectByAccountProjectIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountProjectByAccountProjectIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.accountprojectid = payload[0].AccountProjectId;
                state.selectedRecord = payload[0];
            })
            .addCase(getAccountProjectByAccountProjectIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAssignedProjectList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAssignedProjectList.fulfilled, (state, action) => {
                JSON.parse(action.payload.data).map((item: any) => {
                    delete item.Completed;
                    delete item.CompletedPercent;
                    delete item.Level;
                    delete item.StartDate;
                    delete item.TaskName;
                    delete item.TaskStatusId;
                })
                state.assignedprojectList = JSON.parse(action.payload.data);
                state.isShowGrid = JSON.parse(action.payload.data).length > 0 ? true : false;
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAssignedProjectList.rejected, (state) => {
                state.status = 'failed';
            })
         
        // .addCase(getAccountProjectsByAccountIdAndIsDisabledAsync.pending, (state) => {
        //     state.status = 'loading';
        // })
        // .addCase(getAccountProjectsByAccountIdAndIsDisabledAsync.fulfilled, (state, action) => {
        //     state.status = 'idle';
        //     action.payload.map((item: any) => {
        //         item.value = item.AccountProjectId;
        //         item.label = item.ProjectName;
        //     });
        //     action.payload.unshift({ value: '0', label: 'All' });
        //     state.projectList = action.payload;
        // })
        // .addCase(getAccountProjectsByAccountIdAndIsDisabledAsync.rejected, (state) => {
        //     state.status = 'failed';
        // })
    }
})

export const {
    setDatesAllocationHours, setValuesAllocationHours, isEditableAllocationHoursList, updateSelectedResource, updateUnSelectedResource, updateAllSelectedAndUnSelected, updatePagination, updateSearchPagination,
    updateAccountProjectId, updateIsLoading, updateProjectTemplateStatus, selectedAndUnSelectedOnEditMode, checkedAllState, unCheckedAllState, checkedState,
    unCheckedState, setOptionProjectValue, updateIsTemplate, searchProjectTeam, resetProjectTeam, resetSelectedRecordObjectInState, updateProjectAttachment, updateSorting,
    updateMyProjectFilters, updateActiveFilter, updateFromProjectSummary
} = projectSlice.actions
export const ProjectState = (state: RootState) => state.project
export default projectSlice.reducer